import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel, SearchAddressModel } from 'src/app/models/address.model';
import { AddressService } from 'src/app/services/address.service';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.scss'],
})
export class AutoCompleteComponent implements OnInit {

  @Input() address: AddressModel;
  @Output() addressChanged = new EventEmitter<AddressModel>();

  postCode: string;
  addressLine: string;

  searchResults: SearchAddressModel[];

  isSearching: boolean = false;
  temp: any;
  hasResults = false;

  constructor(private addressService: AddressService) {
  }

  async saveAddress(event: any) {
    this.temp = event.target.value;
  }

  ngOnInit() {
  }

  async submitSearch(text: string) {
    await this.doSearch(text);
  }

  clear() {
    this.address = null;
    this.hasResults = false;
    this.searchResults = null;
    this.addressChanged.emit(this.address);
  }

  async setAddress(address: SearchAddressModel) {
    if (address.type === 'Container') {
      await this.doSearch(this.postCode || this.addressLine, address.id);
      return;
    }

    this.address = await this.addressService.getAddress(address.id);
    this.addressChanged.emit(this.address);
  }

  manual() {
    this.address = {
      buildingName: "",
      buildingNumber: "",
      city: "",
      country: "GB",
      county: "",
      postCode: "",
      street: "",
      subBuilding: ""
    }
    this.addressChanged.emit(this.address);
  }

  trackById(index: any, item: any): void {
    return item._id;
  }

  private async doSearch(text: string, container?: string) {
    if (!text) {
      this.searchResults = null;
      this.hasResults = false;
      return;
    }

    this.isSearching = true;
    try {
      this.searchResults = await this.addressService.searchAddress(text, container);
      this.hasResults = this.searchResults.length > 0;
    } finally {
      this.isSearching = false;
    }
  }
}
